import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import BackCard from './OfferBackCard.jsx';
import FrontCard from './OfferFrontCard.jsx';
import SearchCard from '../SearchCard.jsx';

export default class OfferSearchCard extends PureComponent {
  static propTypes = {
    isAdmin: PropTypes.bool,
    link: PropTypes.string.isRequired,
    offer: PropTypes.object.isRequired,
  };

  static defaultProps = {
    isAdmin: false,
  };

  render() {
    const {offer, ...props} = this.props;

    return <SearchCard className="offer-search-card" link={props.link}>
      <FrontCard isAdmin={props.isAdmin} offer={offer}/>
      <BackCard offer={offer}/>
    </SearchCard>
  }
}